<!-- Modal de detalle (incidente #27). max-w-3xl: el documento del cliente lleva tabla de ítems. -->
<app-modal [isOpen]="isOpen" (close)="cerrar()" className="max-w-3xl mx-4 sm:mx-6">
  <div class="p-4 sm:p-5 space-y-4">

    <!-- Loading -->
    @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando cotización...</span>
    </div>
    }

    <!-- Error -->
    @if (error) {
    <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-error-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
      <button type="button" (click)="cerrar()"
        class="mt-3 px-3 py-1.5 text-sm rounded-lg font-medium bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
        Cerrar
      </button>
    </div>
    }

    @if (!loading && quote) {

    <!-- ============ Encabezado + barra de acciones ============ -->
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <!-- Identidad -->
      <div class="min-w-0">
        <div class="flex items-center gap-2 flex-wrap">
          <h2 class="text-xl font-bold text-gray-900 dark:text-white">{{ quote.quoteNumber }}</h2>
          <span class="px-2 py-0.5 text-xs font-semibold rounded-full bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400"
            title="Versión vigente de esta cotización">v{{ quote.version }}</span>
          <app-quote-status-badge [status]="quote.statusName"></app-quote-status-badge>
          @if (quote.requiresApproval) {
          <span class="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400"
            title="Esta cotización debe aprobarse internamente antes de poder publicarse o enviarse al cliente">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            Requiere aprobación
          </span>
          }
        </div>
        <div class="mt-1.5 flex items-center gap-3 text-sm text-gray-500 dark:text-gray-400 flex-wrap">
          @if (quote.companyCommercialName) {
          <span class="truncate">{{ quote.companyCommercialName }}</span>
          <span class="text-gray-300 dark:text-gray-600">·</span>
          }
          <span class="font-semibold text-brand-600 dark:text-brand-400">{{ formatCurrency(quote.totalAmount) }}</span>
        </div>
      </div>

      <!-- Acciones -->
      <div class="flex items-center gap-2 flex-wrap shrink-0">
        <button type="button" (click)="editar()"
          class="px-3.5 py-2 text-sm font-medium text-white bg-brand-600 hover:bg-brand-700 rounded-lg transition-colors flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
          </svg>
          Editar
        </button>

        <button type="button" (click)="descargarPdf()" [disabled]="downloadingPdf"
          class="px-3.5 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg transition-colors disabled:opacity-50 flex items-center gap-2">
          @if (downloadingPdf) {
          <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
          } @else {
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          }
          PDF
        </button>

        @if (isDraftQuote) {
        <button type="button" (click)="solicitarAprobacion()"
          class="px-3.5 py-2 text-sm font-medium rounded-lg transition-colors flex items-center gap-2"
          [ngClass]="isApprovalBlocked
            ? 'text-white bg-violet-600 hover:bg-violet-700'
            : 'text-violet-700 dark:text-violet-400 bg-violet-50 dark:bg-violet-900/20 hover:bg-violet-100 dark:hover:bg-violet-900/30 border border-violet-200 dark:border-violet-800'">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          Solicitar aprobación
        </button>
        }

        <button type="button" (click)="enviarAlCliente()" [disabled]="isPendingApprovalQuote || isApprovalBlocked"
          [title]="isPendingApprovalQuote ? 'En espera de aprobación de ' + (pendingApproval?.approverName || 'el aprobador asignado') : (isApprovalBlocked ? 'Requiere aprobación interna — solicita aprobación primero' : '')"
          class="px-3.5 py-2 text-sm font-medium text-white bg-blue-light-500 hover:bg-blue-light-600 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
          </svg>
          Enviar al cliente
        </button>

        @if (quote.hasPublicLink && publicLinkUrl) {
        <button type="button" (click)="copiarEnlace()"
          class="px-3.5 py-2 text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 rounded-lg transition-colors flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
          </svg>
          Copiar enlace
        </button>
        }
      </div>
    </div>

    <!-- ============ Pestañas ============ -->
    <div class="border border-gray-200 dark:border-gray-700 rounded-xl">
      <!--
        overflow-y-hidden + no-scrollbar (incidente 37): con solo overflow-x-auto, la spec CSS
        convierte el eje Y de 'visible' a 'auto', y el subrayado de la pestaña activa (bottom-0)
        bastaba para disparar una barra vertical. El desplazamiento horizontal se conserva para
        pantallas angostas, pero sin barra visible.
      -->
      <nav class="flex items-center gap-1 px-2 sm:px-3 pt-2 border-b border-gray-200 dark:border-gray-700 overflow-x-auto overflow-y-hidden no-scrollbar">
        @for (tab of tabs; track tab.id) {
        <button type="button" (click)="setTab(tab.id)"
          class="relative px-3.5 py-2.5 text-sm font-medium whitespace-nowrap transition-colors"
          [class]="activeTab === tab.id
            ? 'text-brand-600 dark:text-brand-400'
            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'">
          {{ tab.label }}
          @if (tab.id === 'aprobaciones' && approvals.length > 0) {
          <span class="ml-1 px-1.5 py-0.5 text-[10px] rounded-full bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400">{{ approvals.length }}</span>
          }
          @if (activeTab === tab.id) {
          <span class="absolute left-0 right-0 bottom-0 h-0.5 bg-brand-500 rounded-full"></span>
          }
        </button>
        }
      </nav>

      <div class="p-4 sm:p-5">

        <!-- ===== Tab: Resumen ===== -->
        @if (activeTab === 'resumen') {
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">

          <!-- Cliente -->
          <div class="rounded-xl border border-gray-200 dark:border-gray-700 p-4">
            <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">Cliente</h3>
            <dl class="space-y-2.5 text-sm">
              @if (quote.companyCommercialName || quote.clientCompanyName) {
              <div class="flex justify-between gap-3">
                <dt class="text-gray-500 dark:text-gray-400">Empresa</dt>
                <dd class="font-medium text-gray-800 dark:text-white/90 text-right truncate">{{ quote.companyCommercialName || quote.clientCompanyName }}</dd>
              </div>
              }
              <div class="flex justify-between gap-3">
                <dt class="text-gray-500 dark:text-gray-400">Contacto</dt>
                <dd class="font-medium text-gray-800 dark:text-white/90 text-right truncate">{{ quote.contactFullName || quote.clientContactName || '—' }}</dd>
              </div>
              @if (quote.contactEmail || quote.clientEmail) {
              <div class="flex justify-between gap-3">
                <dt class="text-gray-500 dark:text-gray-400">Correo</dt>
                <dd class="font-medium text-gray-800 dark:text-white/90 text-right truncate">
                  <a [href]="'mailto:' + (quote.contactEmail || quote.clientEmail)" class="text-brand-600 dark:text-brand-400 hover:underline">{{ quote.contactEmail || quote.clientEmail }}</a>
                </dd>
              </div>
              }
              @if (quote.contactPhone || quote.clientPhone) {
              <div class="flex justify-between gap-3">
                <dt class="text-gray-500 dark:text-gray-400">Teléfono</dt>
                <dd class="font-medium text-gray-800 dark:text-white/90 text-right">{{ quote.contactPhone || quote.clientPhone }}</dd>
              </div>
              }
              @if (quote.sellerFullName) {
              <div class="flex justify-between gap-3 border-t border-gray-100 dark:border-gray-800 pt-2.5">
                <dt class="text-gray-500 dark:text-gray-400">Vendedor</dt>
                <dd class="font-medium text-gray-800 dark:text-white/90 text-right truncate">{{ quote.sellerFullName }}</dd>
              </div>
              }
            </dl>
          </div>

          <!-- Fechas + ciclo de vida -->
          <div class="rounded-xl border border-gray-200 dark:border-gray-700 p-4">
            <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">Fechas Clave</h3>
            <dl class="space-y-2.5 text-sm">
              <div class="flex justify-between gap-3">
                <dt class="text-gray-500 dark:text-gray-400">Emitida</dt>
                <dd class="font-medium text-gray-800 dark:text-white/90 text-right">{{ formatDate(quote.datetimeIssued) }}</dd>
              </div>
              <div class="flex justify-between gap-3">
                <dt class="text-gray-500 dark:text-gray-400">Válida hasta</dt>
                <dd class="font-medium text-gray-800 dark:text-white/90 text-right">{{ formatDate(expiresDate) }}</dd>
              </div>
              <div class="flex justify-between gap-3">
                <dt class="text-gray-500 dark:text-gray-400">Enviada</dt>
                <dd class="font-medium text-gray-800 dark:text-white/90 text-right">{{ formatDateTime(quote.datetimeSent) }}</dd>
              </div>
              <div class="flex justify-between gap-3">
                <dt class="text-gray-500 dark:text-gray-400">Vista por el cliente</dt>
                <dd class="font-medium text-gray-800 dark:text-white/90 text-right">{{ formatDateTime(quote.datetimeViewed) }}</dd>
              </div>
              <div class="flex justify-between gap-3">
                <dt class="text-gray-500 dark:text-gray-400">Aceptada</dt>
                <dd class="font-medium text-gray-800 dark:text-white/90 text-right">{{ formatDateTime(quote.datetimeApproved) }}</dd>
              </div>
              <div class="flex justify-between gap-3">
                <dt class="text-gray-500 dark:text-gray-400">Rechazada</dt>
                <dd class="font-medium text-gray-800 dark:text-white/90 text-right">{{ formatDateTime(quote.datetimeRejected) }}</dd>
              </div>
            </dl>

            @if (lifecycleRows.length > 0) {
            <div class="mt-3 pt-3 border-t border-gray-100 dark:border-gray-800">
              <p class="text-[11px] font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide mb-2">Ciclo de vida</p>
              <ul class="space-y-1.5">
                @for (row of lifecycleRows; track row.label) {
                <li class="flex items-center justify-between gap-3 text-xs text-gray-500 dark:text-gray-400">
                  <span class="inline-flex items-center gap-1.5 min-w-0">
                    <svg class="w-3.5 h-3.5 shrink-0 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                    <span class="truncate">{{ row.label }}</span>
                  </span>
                  <span class="font-medium text-gray-600 dark:text-gray-300 shrink-0">{{ row.value }}</span>
                </li>
                }
              </ul>
            </div>
            }
          </div>

          <!-- Motivo de rechazo del cliente -->
          @if (quote.rejectionReason) {
          <div class="lg:col-span-2 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-xl p-4">
            <div class="flex items-center gap-2 mb-2">
              <svg class="w-4 h-4 text-error-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <h3 class="text-xs font-semibold text-error-600 dark:text-error-400 uppercase tracking-wide">Motivo de rechazo</h3>
            </div>
            <p class="text-sm font-medium text-gray-800 dark:text-white/90">{{ rejectionReasonLabel }}</p>
            @if (quote.rejectionComment) {
            <p class="mt-1.5 text-sm text-gray-600 dark:text-gray-400 italic whitespace-pre-line">"{{ quote.rejectionComment }}"</p>
            }
          </div>
          }

          <!-- Notas internas heredadas del formulario (campo internalNotes) -->
          @if (quote.internalNotes) {
          <div class="lg:col-span-2 bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-500/20 rounded-xl p-4">
            <h3 class="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wide mb-2">Notas internas (del formulario)</h3>
            <p class="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-line">{{ quote.internalNotes }}</p>
            <p class="mt-2 text-[11px] text-amber-600/80 dark:text-amber-500/80">Solo visibles para tu equipo. Para conversación interna usa la pestaña "Notas".</p>
          </div>
          }

          <!-- Enlace público -->
          @if (quote.hasPublicLink) {
          <div class="lg:col-span-2 rounded-xl border border-gray-200 dark:border-gray-700 p-4">
            <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Enlace público</h3>
            @if (publicLinkUrl) {
            <div class="flex items-center gap-2 flex-wrap">
              <code class="flex-1 min-w-0 truncate text-xs text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-800 rounded-lg px-3 py-2">{{ publicLinkUrl }}</code>
              <button type="button" (click)="copiarEnlace()"
                class="shrink-0 px-3 py-2 text-xs font-medium text-white bg-teal-600 hover:bg-teal-700 rounded-lg transition-colors">
                Copiar
              </button>
            </div>
            } @else {
            <p class="text-xs text-gray-500 dark:text-gray-400">
              Esta cotización tiene un enlace público activo. El enlace solo se muestra al generarlo desde el editor.
            </p>
            }
          </div>
          }
        </div>
        }

        <!-- ===== Tab: Documento ===== -->
        @if (activeTab === 'documento') {
        <div class="space-y-4">
          <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-5 sm:p-7 border-t-4"
            [style.border-top-color]="docData?.accentColor">
            @if (docData) {
            <app-quote-document [data]="docData"></app-quote-document>
            }
          </div>
          @if (quote.versionNotes) {
          <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-5">
            <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5">Notas de Versión</h3>
            <p class="text-sm text-gray-700 dark:text-gray-300 italic whitespace-pre-line">{{ quote.versionNotes }}</p>
          </div>
          }
        </div>
        }

        <!-- ===== Tab: Aprobaciones ===== -->
        @if (activeTab === 'aprobaciones') {
        @if (isCurrentUserApprover) {
        <div class="mb-4 p-3 rounded-lg bg-violet-50 dark:bg-violet-900/20 border border-violet-200 dark:border-violet-800">
          <p class="text-xs text-violet-700 dark:text-violet-400 mb-2 font-medium">Esta cotización espera tu aprobación.</p>
          <div class="flex flex-wrap gap-1.5">
            <button type="button" (click)="abrirDecision('APPROVED')"
              class="px-3 py-1.5 text-xs font-medium text-white bg-success-600 hover:bg-success-700 rounded-lg transition-colors">Aprobar</button>
            <button type="button" (click)="abrirDecision('CHANGES_REQUESTED')"
              class="px-3 py-1.5 text-xs font-medium text-white bg-amber-500 hover:bg-amber-600 rounded-lg transition-colors">Solicitar cambios</button>
            <button type="button" (click)="abrirDecision('REJECTED')"
              class="px-3 py-1.5 text-xs font-medium text-white bg-error-600 hover:bg-error-700 rounded-lg transition-colors">Rechazar</button>
          </div>
        </div>
        }

        @if (approvals.length === 0) {
        <div class="flex flex-col items-center gap-2 py-10 text-gray-400 dark:text-gray-500">
          <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <p class="text-sm">No hay solicitudes de aprobación interna para esta cotización.</p>
        </div>
        } @else {
        <ol class="space-y-3">
          @for (approval of approvals; track approval.id) {
          <li class="border border-gray-200 dark:border-gray-700 rounded-lg p-3">
            <div class="flex items-center justify-between gap-2 flex-wrap">
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium" [ngClass]="approvalStatusChip(approval)">
                {{ approvalStatusLabel(approval) }}
              </span>
              <time class="text-xs text-gray-400 dark:text-gray-500" [title]="formatDateTime(approval.datetimeRequested)">
                {{ formatDateTime(approval.datetimeRequested) }}
              </time>
            </div>
            <p class="mt-1.5 text-xs text-gray-600 dark:text-gray-400">
              <span class="font-medium text-gray-800 dark:text-white/90">{{ approval.requesterName }}</span>
              <span class="mx-1">→</span>
              <span class="font-medium text-gray-800 dark:text-white/90">{{ approval.approverName }}</span>
            </p>
            @if (approval.requestComment) {
            <p class="mt-1 text-xs text-gray-500 dark:text-gray-400 italic whitespace-pre-line">"{{ approval.requestComment }}"</p>
            }
            @if (approval.datetimeDecided) {
            <div class="mt-2 pt-2 border-t border-gray-100 dark:border-gray-800">
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Decidida {{ approvalDecidedVia(approval) }} · {{ formatDateTime(approval.datetimeDecided) }}
              </p>
              @if (approval.decisionComment) {
              <p class="mt-1 text-xs text-gray-500 dark:text-gray-400 italic whitespace-pre-line">"{{ approval.decisionComment }}"</p>
              }
            </div>
            }
          </li>
          }
        </ol>
        }
        }

        <!-- ===== Tab: Versiones ===== -->
        @if (activeTab === 'versiones') {
        @if (loadingVersions) {
        <div class="flex justify-center items-center py-8">
          <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
          <span class="ml-3 text-sm text-gray-500 dark:text-gray-400">Cargando versiones...</span>
        </div>
        } @else if (versionsError) {
        <div class="rounded-lg border border-error-200 bg-error-50 p-3 dark:border-error-500/20 dark:bg-error-500/10">
          <p class="text-sm text-error-600 dark:text-error-400">{{ versionsError }}</p>
        </div>
        } @else if (versions.length === 0) {
        <p class="text-sm text-gray-500 dark:text-gray-400 text-center py-8">No hay versiones registradas.</p>
        } @else {
        <p class="text-xs text-gray-500 dark:text-gray-400 mb-3">
          Todas las versiones comparten el número <span class="font-medium">{{ quote.quoteNumber }}</span>.
        </p>
        <ul class="space-y-2.5">
          @for (v of versions; track v.id) {
          <li class="flex items-start gap-3 px-4 py-3 rounded-lg border transition-colors"
            [class]="v.isCurrent
              ? 'border-brand-300 bg-brand-50/50 dark:border-brand-700 dark:bg-brand-900/10'
              : 'border-gray-200 dark:border-gray-700'">
            <span class="shrink-0 w-10 text-center px-2 py-1 text-xs font-bold rounded"
              [class]="v.isCurrent
                ? 'bg-brand-100 text-brand-700 dark:bg-brand-900/40 dark:text-brand-400'
                : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400'">
              v{{ v.version }}
            </span>
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 flex-wrap">
                <app-quote-status-badge [status]="v.statusName"></app-quote-status-badge>
                @if (v.isCurrent) {
                <span class="px-2 py-0.5 text-xs font-medium rounded-full bg-success-100 text-success-700 dark:bg-success-900/30 dark:text-success-400">Vigente</span>
                }
                @if (v.id === quoteId) {
                <span class="text-xs text-gray-400 dark:text-gray-500">(estás viendo esta versión)</span>
                }
              </div>
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                Creada por <span class="font-medium text-gray-700 dark:text-gray-300">{{ v.userCreatedName || 'Sistema' }}</span>
                · {{ formatDate(v.datetimeCreated) }}
              </p>
              @if (v.versionNotes) {
              <p class="text-xs text-gray-600 dark:text-gray-400 italic mt-1 whitespace-pre-line">"{{ v.versionNotes }}"</p>
              }
            </div>
            <div class="shrink-0 flex flex-col items-end gap-1.5">
              @if (v.id !== quoteId) {
              <button type="button" (click)="verDetalleVersion(v)"
                class="text-xs font-medium text-brand-600 dark:text-brand-400 hover:underline">Ver detalle</button>
              }
              @if (!v.isCurrent) {
              <button type="button" (click)="restaurarVersion(v)" [disabled]="restoringVersionId !== null"
                class="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors disabled:opacity-50">
                @if (restoringVersionId === v.id) {
                <div class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-current"></div>
                } @else {
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                </svg>
                }
                Restaurar
              </button>
              }
            </div>
          </li>
          }
        </ul>
        }
        }

        <!-- ===== Tab: Notas ===== -->
        @if (activeTab === 'notas') {
        <app-quote-notes [quoteId]="quoteId"></app-quote-notes>
        }

        <!-- ===== Tab: Línea de tiempo ===== -->
        @if (activeTab === 'timeline') {
        <app-audit-timeline
          [logs]="timelineLogs"
          [loading]="loadingTimeline"
          [error]="timelineError"
          [currentPage]="timelinePage"
          [totalPages]="timelineTotalPages"
          [totalElements]="timelineTotalElements"
          [emptyMessage]="timelineEmptyMessage"
          (pageChange)="loadTimeline($event)">
        </app-audit-timeline>
        }

        <!-- ===== Tab: Adjuntos ===== -->
        @if (activeTab === 'adjuntos') {
        <app-quote-attachments [quoteId]="quoteId"></app-quote-attachments>
        }

      </div>
    </div>

    }
  </div>
</app-modal>

<!-- Modales anidados: HERMANOS de <app-modal> (no hijos) para no quedar atrapados en su
     stacking context. Mismo token z-modal → gana el orden del DOM y quedan encima del detalle. -->

<!-- Modal: solicitar aprobación interna (RF-001) -->
<app-quote-request-approval-modal
  [isOpen]="showRequestApprovalModal"
  [quoteId]="quoteId"
  [quoteNumber]="quote?.quoteNumber || ''"
  (closed)="cerrarSolicitarAprobacion()"
  (requested)="onAprobacionSolicitada()">
</app-quote-request-approval-modal>

<!-- Modal: decidir aprobación (RF-002, aprobador asignado) -->
<app-quote-approval-decision-modal
  [isOpen]="showDecisionModal"
  [approvalId]="pendingApproval?.id ?? null"
  [decision]="decisionToMake"
  [quoteNumber]="quote?.quoteNumber || ''"
  (closed)="cerrarDecision()"
  (decided)="onDecidido()">
</app-quote-approval-decision-modal>
